module.exports = __webpack_public_path__ + "img/stock6.1c910bc7.png";